import {VideoPositioningStrategy, VideoSizeResult} from './abstractions';

export class MinimizedSquareVideoStrategy extends VideoPositioningStrategy {
    constructor(window) {
        super();
        this._window = window;
    }

    getVideoNewSize() {
        const {maxWidth, maxHeight} = this._getSizeLimits();

        return new VideoSizeResult(maxWidth, maxHeight);
    }

    updateVideoSize(elVideo, videoNewSize, videoMeta) {
        super.updateVideoSize(elVideo, videoNewSize, videoMeta);
        const element = elVideo instanceof HTMLElement ? elVideo : elVideo[0];

        if (element && element.tagName === 'VIDEO') {
            element.style.objectFit = 'cover';
        }
    }

    updateVideoLocation(videoSize, elContainer, videoWasManuallyMoved) {
        super.updateVideoLocation(videoSize, elContainer, videoWasManuallyMoved);

        const element = elContainer instanceof HTMLElement ? elContainer : elContainer[0];

        if (element) {
            element.style.display = 'flex';

            if (!videoWasManuallyMoved) {
                const mainContainer = document.querySelector('.dashboard-main-content-container');
                if (mainContainer) {
                    const offset = mainContainer.getBoundingClientRect();
                    const x = offset.left + window.scrollX + 17;
                    const y = offset.top + window.scrollY + 20;

                    element.style.left = x + 'px';
                    element.style.top = y + 'px';
                    element.style.right = 'auto';
                    element.style.bottom = 'auto';
                }
            }
        }
    }

    _getSizeLimits() {
        return {
            maxWidth: 205,
            maxHeight: 320
        };
    }
}
